import React, { FunctionComponent } from 'react';
import type { Brand } from '../../../types/brand';
import { ComponentProps } from './types';

type Props = ComponentProps & {
  brandData: Brand | null;
  companyId: number | null;
};

export const Presentation: FunctionComponent<Props> = ({
  brandData,
  companyId,
  instagramIcon,
  noimage,
  hoverIcon,
  isPc,
  dataCategory,
  dataValue,
}) => {
  if (!brandData) return null;
  const imageUrl = brandData.image || noimage;
  const brandName = brandData.name ? `${brandData.name.truncated} | ${brandData.name.full}` : 'ブランド名不明';

  return (
    <div className="brand-card">
      <article className="brand-card__container">
        <a
          href={`/brands/${brandData.id}`}
          className="brand-card__link gtm-brand-view-count"
          data-event-name='brand on screen'
          data-event="click"
          data-category={dataCategory}
          data-value={dataValue.brandCard}
          data-brandid={brandData.id}
          data-companyid={companyId}
        >
          <div className="brand-card__image">
            <img src={imageUrl} alt={`${brandName}の画像`} className="brand-card__image--content" />
            {isPc && (
              <div className="brand-card__hover">
                <img src={hoverIcon} alt="" />
              </div>
            )}
          </div>
          <div className="brand-card__info">
            <h3 className="brand-card__name">{brandName}</h3>
            {brandData.description && <p className="brand-card__description">{brandData.description.truncated}</p>}
          </div>
        </a>
        <div className="brand-card__footer">
          <p className={`brand-card__unit ${brandData.recruitmentCount === 0 ? 'none' : ''}`}>
            募集中求人{brandData.recruitmentCount}件
          </p>
          {brandData.instagramUrl && (
            <a
              href={brandData.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="brand-card__instagram gtm-instagram-view-count"
              data-event-name='instagram on screen'
              data-event="click"
              data-category={dataCategory}
              data-value={dataValue.brandcardInstagram}
              data-brandid={brandData.id}
              data-companyid={companyId}
            >
              <img src={instagramIcon} alt={brandData.instagramUrl} />
            </a>
          )}
        </div>
      </article>
    </div>
  );
};
